export enum ScoreEnum {
    "?" = 0,
    F,
    D,
    C,
    B,
    A,
}

export const getAverageScoreLabel = (score: number | undefined, reviewNum?: number) => {
    if (reviewNum === 0 || score === undefined || score === 0 || isNaN(score)) {
        return "?"
    }
    return [
        "F",
        "F",
        "F",
        "D-",
        "D",
        "D+",
        "C-",
        "C",
        "C+",
        "B-",
        "B",
        "B+",
        "A-",
        "A",
        "A+",
        "A+",
        "A+",
        "A+",
    ][Math.floor(score * 3)]
}
